// extracted by mini-css-extract-plugin
export var tosLink = "_bn-0";